import React from 'react';

function Notes(props: object) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.4637 13.2849L22.5656 16.9892C21.7958 20.1883 20.2745 21.4821 17.4153 21.2162C16.957 21.1808 16.4622 21.101 15.9306 20.977L14.391 20.6225C10.5695 19.7452 9.3873 17.9196 10.2854 14.2154L11.1835 10.5024C11.3668 9.74911 11.5867 9.09333 11.8617 8.55277C12.9339 6.40822 14.7576 5.83221 17.8185 6.53229L19.3489 6.87789C23.1888 7.74635 24.3618 9.58073 23.4637 13.2849Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 20.7293C16.9665 21.0814 16.2953 21.3748 15.4779 21.6346L14.1183 22.0706C10.7022 23.1436 8.90375 22.2466 7.79372 18.9186L6.6923 15.6073C5.59088 12.2792 6.50299 10.5188 9.91912 9.44579L11.2787 9.00987C11.6315 8.90089 11.9671 8.80868 12.2855 8.75C12.0273 9.26136 11.8208 9.8817 11.6487 10.5943L10.8054 14.1067C9.96215 17.6108 11.0722 19.3377 14.6604 20.1676L16.106 20.5029C16.6051 20.6203 17.0698 20.6957 17.5 20.7293Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 18.75C27.5 23.5875 23.5875 27.5 18.75 27.5L20.0625 25.3125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 11.25C2.5 6.4125 6.4125 2.5 11.25 2.5L9.9375 4.6875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Notes;
